export enum FindAllNewsSort {
  TITLE = 'title',
  STATUS = 'status',
  CREATED_DATE = 'createdDate',
  UPDATED_DATE = 'updatedDate',
  PUBLISHED_DATE = 'publishedDate',
}
